module.exports = __webpack_public_path__ + "static/media/credentialing-vendors-manage.c7819ed7.svg";